const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M16.872 19.034A.75.75 0 0 0 18 18.386V5.614a.75.75 0 0 0-1.128-.648l-10.78 6.3a.85.85 0 0 0 0 1.468zm2.628-.648c0 1.737-1.885 2.82-3.385 1.943l-10.78-6.3c-1.552-.907-1.552-3.15 0-4.058l10.78-6.3c1.5-.876 3.385.206 3.385 1.943z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
